export default __webpack_public_path__ + "static/media/registrationMeters.168a29cf.svg";